import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import {
	BpTableCellLineTemplateDirective,
	BpTableCellLogoTemplateDirective,
	BpTableCellOverflowEllipsisDirective,
	BpTableCellTemplateDirective,
	BpTableComponent,
	BpTableMessageTemplateDirective,
	BpTableHeaderCellTemplateDirective,
	BpTableHeaderTemplateDirective,
	BpTableRowTemplateDirective
} from "@modules/shared/bp-table/bp-table.component";
import { MatSortModule } from "@angular/material/sort";
import { DragDropModule } from "@angular/cdk/drag-drop";

const components = [
	BpTableComponent,
	BpTableHeaderTemplateDirective,
	BpTableRowTemplateDirective,
	BpTableCellTemplateDirective,
	BpTableHeaderCellTemplateDirective,
	BpTableCellLineTemplateDirective,
	BpTableCellLogoTemplateDirective,
	BpTableCellOverflowEllipsisDirective,
	BpTableMessageTemplateDirective
];

@NgModule({
	imports: [CoreModule, MatSortModule, DragDropModule],
	declarations: [components],
	exports: [components]
})
export class BpTableModule {}
